import { useParams } from 'react-router-dom';
import { ProductForm } from './form/ProductForm';
import { getShopProductUrl, getUrlParam } from '../../helpers/helpers';

export const EditProduct = () => {
  const { id } = useParams();
  const returnTo = getUrlParam('returnTo');

  const onBackClick = () => {
    if (returnTo === 'shop') {
      window.location = getShopProductUrl(id);
    } else {
      window.history.back();
    }
  };

  return <ProductForm productId={Number(id)} onBackClick={onBackClick} />;
};
